class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.scopeResultIds();
        this.open();

      })
      .catch((error) => {
        this.close();

        throw error;
      });
  }

  scopeResultIds() {
    const suffix = this.input.id ? `-${this.input.id}` : '';
    if (!suffix) return;
    this.predictiveSearchResults.querySelectorAll('[id]').forEach((el) => {
      el.id = `${el.id}${suffix}`;
    });
    const listbox = this.predictiveSearchResults.querySelector('[role="listbox"]');
    if (listbox) {
      this.input.setAttribute('aria-owns', listbox.id);
      this.input.setAttribute('aria-controls', listbox.id);
    }
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    $(".mobile-header .mobile-sidebar .ms-bottom").addClass("predictive-open");
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    $(".mobile-header .mobile-sidebar .ms-bottom").removeClass("predictive-open");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
